// extracted by mini-css-extract-plugin
module.exports =  {"response-item":"ResponseItem-O229__response-item","response-label":"ResponseItem-ni0c__response-label"};